import { render, staticRenderFns } from "./WidgetImageUploader.vue?vue&type=template&id=f0556a5a&scoped=true&"
import script from "./WidgetImageUploader.vue?vue&type=script&lang=js&"
export * from "./WidgetImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./WidgetImageUploader.vue?vue&type=style&index=0&id=f0556a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0556a5a",
  null
  
)

export default component.exports